import { schemes, zSchema } from "@zeal/common";

export const resolveWorkersByExternalIdsRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  externalIds: zSchema.array(zSchema.string().min(1)).min(1).max(500),
});

export type TResolveWorkersByExternalIdsRequestSchema = zSchema.infer<
  typeof resolveWorkersByExternalIdsRequestSchema
>;

const resolvedPairSchema = zSchema.object({
  employeeID: zSchema.string(),
  externalId: zSchema.string(),
});

export const resolveWorkersByExternalIdsResponseSchema = zSchema.object({
  resolved: zSchema.array(resolvedPairSchema),
  unresolved: zSchema.array(zSchema.string()),
});

export type TResolveWorkersByExternalIdsResponseSchema = zSchema.infer<
  typeof resolveWorkersByExternalIdsResponseSchema
>;
